import { BarChart3, TrendingUp, Users, FileText, Calendar } from 'lucide-react';

const Analytics = () => {
  const stats = [
    {
      title: 'Total Forms',
      value: '24',
      change: '+12%',
      trend: 'up',
      icon: FileText,
    },
    {
      title: 'Active Users',
      value: '1,284',
      change: '+18%',
      trend: 'up',
      icon: Users,
    },
    {
      title: 'Form Submissions',
      value: '8,392',
      change: '+24%',
      trend: 'up',
      icon: TrendingUp,
    },
    {
      title: 'Monthly Growth',
      value: '32%',
      change: '+8%',
      trend: 'up',
      icon: Calendar,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <BarChart3 className="h-6 w-6 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-foreground">Analytics</h1>
          <p className="text-muted-foreground">Track performance and user engagement</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="bg-card rounded-lg border border-border p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">{stat.title}</p>
                  <p className="text-2xl font-bold text-foreground mt-2">{stat.value}</p>
                  <p className="text-sm text-green-600 mt-1 flex items-center gap-1">
                    <TrendingUp className="h-3 w-3" />
                    {stat.change} from last month
                  </p>
                </div>
                <div className="p-3 bg-primary/10 rounded-lg">
                  <Icon className="h-6 w-6 text-primary" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-card rounded-lg border border-border p-6">
          <h3 className="text-lg font-semibold text-foreground mb-4">Form Submissions Over Time</h3>
          <div className="h-64 flex items-end justify-center bg-gray-50 rounded-lg">
            <div className="flex items-end gap-2 h-32">
              {[20, 35, 25, 45, 30, 55, 40].map((height, index) => (
                <div
                  key={index}
                  className="bg-primary rounded-t w-8 transition-all hover:bg-primary/80"
                  style={{ height: `${height}%` }}
                />
              ))}
            </div>
          </div>
          <div className="flex justify-between text-xs text-muted-foreground mt-2">
            <span>Mon</span>
            <span>Tue</span>
            <span>Wed</span>
            <span>Thu</span>
            <span>Fri</span>
            <span>Sat</span>
            <span>Sun</span>
          </div>
        </div>

        <div className="bg-card rounded-lg border border-border p-6">
          <h3 className="text-lg font-semibold text-foreground mb-4">Top Performing Forms</h3>
          <div className="space-y-4">
            {[
              { name: 'Contact Form', submissions: 1284, percentage: 85 },
              { name: 'Newsletter Signup', submissions: 892, percentage: 65 },
              { name: 'Survey Form', submissions: 654, percentage: 45 },
              { name: 'Feedback Form', submissions: 432, percentage: 30 },
            ].map((form, index) => (
              <div key={index} className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-foreground font-medium">{form.name}</span>
                  <span className="text-muted-foreground">{form.submissions}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-primary h-2 rounded-full transition-all"
                    style={{ width: `${form.percentage}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Recent Activity</h3>
        <div className="space-y-4">
          {[
            { action: 'New form created', user: 'John Doe', time: '2 hours ago' },
            { action: 'Form submission received', user: 'Contact Form', time: '3 hours ago' },
            { action: 'User registered', user: 'Jane Smith', time: '5 hours ago' },
            { action: 'Form updated', user: 'Mike Johnson', time: '1 day ago' },
            { action: 'Analytics report generated', user: 'System', time: '2 days ago' },
          ].map((activity, index) => (
            <div key={index} className="flex items-center justify-between py-2">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-primary rounded-full" />
                <div>
                  <p className="text-sm font-medium text-foreground">{activity.action}</p>
                  <p className="text-xs text-muted-foreground">{activity.user}</p>
                </div>
              </div>
              <span className="text-xs text-muted-foreground">{activity.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Analytics;